// In theory this file should be replaced with local apollo resolvers once we have cache persistence

const expKey = 'dismissedExperiences'

function getDismissedExperiences(): string[] {
  const storage = window.localStorage.getItem(expKey)
  return storage ? JSON.parse(storage) : []
}

export function addDismissedExperience(experience: string): void {
  if (typeof window === 'undefined') {
    return
  }
  const dismissedExperiences = getDismissedExperiences()
  if (!dismissedExperiences.includes(experience)) {
    dismissedExperiences.push(experience)
    window.localStorage.setItem(expKey, JSON.stringify(dismissedExperiences))
  }
}

export function experienceWasDismissed(experience: string): boolean {
  if (typeof window === 'undefined') {
    return true
  }
  return getDismissedExperiences().includes(experience)
}
